export const environment = {
  production: false,
  API_URL: 'https://api2.bistronex.com',
  API_KEY: 'test',
  DEFAULT_PACKAGE_TABLE_ID: '1tzhigfrukspwrm',
};
